import withValidations from '../../../common/withValidations';
import styledFrame from './BillToFacility.frame';

export function coverageChanged(props, nextProps) {
  const policyChanged = nextProps.billToFacilityPayer?.policyNumber !== props.billToFacilityPayer?.policyNumber;
  const authChanged =
    nextProps.billToFacilityPayer?.authorizationNumber !== props.billToFacilityPayer?.authorizationNumber;
  return policyChanged || authChanged;
}

export function shouldValidateAll(props, nextProps) {
  const validateAll = nextProps.shouldValidateAll !== props.shouldValidateAll && nextProps.shouldValidateAll;
  const triggerValidation = nextProps.triggerValidation !== props.triggerValidation && nextProps.triggerValidation;
  const triggerBillToFacilityValidation =
    nextProps.triggerBillToFacilityValidation !== props.triggerBillToFacilityValidation &&
    nextProps.triggerBillToFacilityValidation;
  const triggerPatientValidation =
    nextProps.triggerPatientValidation !== props.triggerPatientValidation && nextProps.triggerPatientValidation;

  return (
    validateAll ||
    triggerValidation ||
    triggerPatientValidation ||
    triggerBillToFacilityValidation ||
    coverageChanged(props, nextProps)
  );
}

const validations = {
  policyNumber: (value, nextProps) => {
    if (value === undefined && nextProps.billToFacilityPayer) {
      value = nextProps.billToFacilityPayer.policyNumber;
    }
    if (!value && nextProps.isBilledToFacility) {
      return 'Specify Bill To Facility Reason';
    }
    return null;
  },
  authorizationNumber: (value, nextProps) => {
    if (value === undefined && nextProps.billToFacilityPayer) {
      value = nextProps.billToFacilityPayer.authorizationNumber;
    }
    if (!value && nextProps.isBilledToFacility) {
      return 'Specify Bill To Facility Authorized By Name';
    }
    return null;
  },
};

export default withValidations(validations)(styledFrame);
